import { reactLocalStorage } from "reactjs-localstorage";
import { toast } from "react-toastify";

// Exact messages beam-service's authenticateJwt middleware returns for a
// missing/invalid/expired token — distinct from other legitimate 401s
// (e.g. "Current password is incorrect") that shouldn't force a logout.
const JWT_ERROR_MESSAGES = [
    "Missing or invalid Authorization header",
    "Missing Bearer token",
    "Invalid or expired token",
];

export function isExpiredSessionError(error) {
    if (error?.response?.status !== 401) return false;
    const message = error?.response?.data?.error || error?.response?.data?.message || "";
    return JWT_ERROR_MESSAGES.includes(message);
}

let loggingOut = false;

export function logoutExpiredSession() {
    if (loggingOut) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get("ssr") === "1") return;

    loggingOut = true;
    reactLocalStorage.remove("token");
    reactLocalStorage.remove("user");
    toast.info("Your session has expired. Please sign in again.");
    window.location.href = "/";
}
